import { _ as _sfc_main } from "./VaCollapse.vue_vue_type_script_lang-b3c2d39a.mjs";
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, withKeys, renderSlot, normalizeProps, guardReactiveProps, mergeProps, createBlock, createCommentVNode, toDisplayString, createVNode, normalizeStyle } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaCollapse_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-collapse__header__text" };
const _hoisted_2 = ["id", "aria-labelledby"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_icon = resolveComponent("va-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["va-collapse", _ctx.computedClasses])
  }, [
    createElementVNode("div", {
      class: "va-collapse__header-wrapper",
      role: "heading",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.toggle && _ctx.toggle(...args)),
      onKeydown: [
        _cache[1] || (_cache[1] = withKeys((...args) => _ctx.toggle && _ctx.toggle(...args), ["enter"])),
        _cache[2] || (_cache[2] = withKeys((...args) => _ctx.toggle && _ctx.toggle(...args), ["space"]))
      ]
    }, [
      renderSlot(_ctx.$slots, "header", normalizeProps(guardReactiveProps({
        value: _ctx.computedModelValue,
        bind: _ctx.headerAttributes,
        attributes: _ctx.headerAttributes
      })), () => [
        createElementVNode("div", mergeProps(_ctx.headerAttributes, {
          class: "va-collapse__header",
          style: _ctx.headerStyle
        }), [
          _ctx.icon ? (openBlock(), createBlock(_component_va_icon, {
            key: 0,
            class: "va-collapse__header__icon",
            name: _ctx.icon,
            color: _ctx.textColorComputed
          }, null, 8, ["name", "color"])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "header-content", normalizeProps(guardReactiveProps({ header: _ctx.header })), () => [
            createElementVNode("div", _hoisted_1, toDisplayString(_ctx.header), 1)
          ]),
          createVNode(_component_va_icon, {
            class: "va-collapse__header__icon",
            name: _ctx.computedModelValue ? "va-arrow-up" : "va-arrow-down",
            color: _ctx.textColorComputed
          }, null, 8, ["name", "color"])
        ], 16)
      ])
    ], 32),
    createElementVNode("div", {
      class: "va-collapse__body-wrapper",
      style: normalizeStyle(_ctx.contentStyle)
    }, [
      createElementVNode("div", {
        class: "va-collapse__body",
        ref: "body",
        role: "region",
        id: _ctx.panelIdComputed,
        "aria-labelledby": _ctx.headerIdComputed
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_2)
    ], 4)
  ], 2);
}
const _VaCollapse = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaCollapse as _
};
//# sourceMappingURL=VaCollapse-e186e2ab.mjs.map
